import styled from 'styled-components';
 
export const DefaultButton = styled.button`
  border: none;
  margin: 0;
  padding: 0;
  width: 100%;
  overflow: visible;
  background: transparent;
  color: inherit;
  font: inherit;
  transition: background-color 0.1s ease, color 0.1s ease;

  :hover {
    cursor: crosshair;
    background-color: ${(props) => props.theme.hoverColor};
  }

  :focus {
    outline: 1px solid ${(props) => props.theme.hoverColor};
  }
`
